import React from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'

interface MultipleChoiceSectionInputProps {
  sectionOptions: {
    option: string
    from: number
    to: number
  }[]
  updateSectionOptions: (newOption: string, optionIndex: number) => void
  updateSectionFrom: (newFrom: number, optionIndex: number) => void
  updateSectionTo: (newTo: number, optionIndex: number) => void
  addNewSectionOption: () => void
  deleteSectionOption: (optionIndex: number) => void
  availableQuestionStart: number
  availableQuestionEnd: number
}

const MultipleChoiceSectionInput: React.FC<MultipleChoiceSectionInputProps> = ({
  sectionOptions = [],
  updateSectionOptions,
  updateSectionFrom,
  updateSectionTo,
  addNewSectionOption,
  deleteSectionOption,
  availableQuestionStart,
  availableQuestionEnd,
}) => {
  const handleSectionOptionsChange = (e: React.FormEvent<HTMLInputElement>, index: number) => {
    updateSectionOptions(e.currentTarget.value, index)
  }

  const handleSectionFromChange = (e: React.FormEvent<HTMLInputElement>, index: number) => {
    updateSectionFrom(Number(e.currentTarget.value), index)
  }

  const handleSectionToChange = (e: React.FormEvent<HTMLInputElement>, index: number) => {
    updateSectionTo(Number(e.currentTarget.value), index)
  }

  const handleAddSectionOption = () => {
    addNewSectionOption()
  }

  const handleDeleteSectionOption = (optionIndex: number) => {
    if (sectionOptions.length === 1) return
    deleteSectionOption(optionIndex)
  }

  return (
    <div className='my-4 ml-2'>
      <div className='flex flex-col gap-2'>
        {sectionOptions.map((item, index) => {
          return (
            <div key={index} className='flex items-center gap-2'>
              <input type='radio' name='' disabled id='' className='form-check-input me-3' />
              <input
                type='text'
                placeholder={`Option ${index + 1}`}
                className='form-control form-control-solid mb-3 mb-lg-0 flex-grow'
                value={item.option}
                onChange={(e) => {
                  handleSectionOptionsChange(e, index)
                }}
              />

              <div className='flex flex-col items-center gap-2 w-25'>
                {index === 0 && <label className='whitespace-nowrap'>Start Question</label>}
                <input
                  type='number'
                  placeholder='From'
                  className='form-control form-control-solid'
                  min={availableQuestionStart}
                  max={Math.min(availableQuestionEnd, item.to)}
                  value={item.from}
                  onChange={(e) => {
                    handleSectionFromChange(e, index)
                  }}
                />
              </div>

              <div className='flex flex-col items-center gap-2 w-25'>
                {index === 0 && <label className='whitespace-nowrap'>End Question</label>}
                <input
                  type='number'
                  placeholder='To'
                  className='form-control form-control-solid'
                  min={Math.min(availableQuestionStart, item.from)}
                  max={availableQuestionEnd}
                  value={item.to}
                  onChange={(e) => {
                    handleSectionToChange(e, index)
                  }}
                />
              </div>

              <button
                className='rounded-lg bg-red-300 p-2'
                type='button'
                onClick={() => handleDeleteSectionOption(index)}
              >
                <KTIcon iconName='trash' className='fs-3' />
              </button>
            </div>
          )
        })}
        <div className='my-2 ml-8'>
          <button
            type='button'
            className='btn btn-secondary btn-sm'
            onClick={handleAddSectionOption}
          >
            Add Option
          </button>
        </div>
      </div>
    </div>
  )
}

export default MultipleChoiceSectionInput
